import React from "react";
import {Skeleton} from "antd";

interface LoaderProps {
    loading: boolean | undefined;
    children: React.ReactNode;
}

const LoadingSkeleton: React.FC<LoaderProps> = (
    {
        loading,
        children,
    }
) => {
    return (
        <Skeleton
            active
            loading={loading}
        >
            {children}
        </Skeleton>
    );
};

export default LoadingSkeleton;